import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=430da5b2"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=430da5b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports